import { useDashboardIncidents } from '@features/home/hooks/useDashboardIncidents'
import { colors } from '@lmc/common/constants'
import { Button, Due, Todo, theme } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { incidentReportsConstants } from 'locale/incidentReports'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { HomeCard } from './index'

export const CaseIncidentsCard: FC = () => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)

  const res = useDashboardIncidents()

  const navigate = useNavigate()

  const renderFooter = () => {
    return (
      <div style={styles.footer}>
        <Text>
          <strong>{res?.totalCount} </strong>
          {t(incidentReportsConstants.DASHBOARD_INCIDENTS_30)}
        </Text>
        <Button
          onClick={() =>
            navigate(`../reports/incidents/list`, {
              relative: 'path'
            })
          }
          variant="default"
          style={{
            marginLeft: 'auto',
            marginRight: 0
          }}
        >
          {t(incidentReportsConstants.DASHBOARD_VIEW_ALL)}
        </Button>
      </div>
    )
  }

  return (
    <HomeCard
      title={t(incidentReportsConstants.DASHBOARD_CARD_TITLE)}
      footer={renderFooter()}
    >
      <div style={{ height: 170 }}>
        <InfoWrapper>
          <div
            onClick={() =>
              navigate(
                `../reports/incidents/list?statuses%5B0%5D=needsReview`,
                {
                  relative: 'path'
                }
              )
            }
          >
            <StyledText $marginTop={0}>
              <Todo />
              <CountWrapper>{res?.needsReview}</CountWrapper>
              <TranslationWrapper>
                &nbsp;
                {t(incidentReportsConstants.DASHBOARD_NEEDS_REVIEW)}
              </TranslationWrapper>
            </StyledText>
          </div>
          <div
            onClick={() =>
              navigate(`../reports/incidents/list?statuses%5B0%5D=open`, {
                relative: 'path'
              })
            }
          >
            <StyledText $marginTop={5}>
              <Due />
              <CountWrapper>{res?.open}</CountWrapper>
              <TranslationWrapper>
                &nbsp;
                {t(incidentReportsConstants.DASHBOARD_OPEN)}
              </TranslationWrapper>
            </StyledText>
          </div>
          <div
            onClick={() =>
              navigate(
                `../reports/incidents/actions?statuses%5B0%5D=notStarted&statuses%5B1%5D=pending`,
                {
                  relative: 'path'
                }
              )
            }
          >
            <StyledText $marginTop={5}>
              <Due color={theme.color.status.warning} />
              <CountWrapper>{res?.openActions}</CountWrapper>
              <TranslationWrapper>
                &nbsp;
                {t(incidentReportsConstants.DASHBOARD_UNRESOLVED)}
              </TranslationWrapper>
            </StyledText>
          </div>
        </InfoWrapper>
      </div>
    </HomeCard>
  )
}

const styles = {
  dot: {
    left: -20,
    top: -18,
    width: 42,
    height: 42,
    border: '3px solid rgba(0,0,0,0)',
    borderRadius: 24,
    backgroundColor: colors.grey,
    alignItems: 'center'
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  iconStyle: {
    backgroundSize: '14px !important',
    backgroundPosition: 'center center !important'
  },
  title: {
    opacity: 0.8
  },
  conflicts: {
    color: colors.red,
    textDecoration: 'underline',
    marginTop: 5,
    display: 'flex',
    alignItems: 'center'
  }
}

const InfoWrapper = styled.div``

const CountWrapper = styled.strong`
  margin-left: 5px;
`

const StyledText = styled(Text)<{ $marginTop: number }>`
  display: flex;
  align-items: center;
  margin-top: ${(props) => props.$marginTop}px;
  color: ${(props) => props.theme.color.neutral.color4};
  cursor: pointer;

  &:hover {
	text-decoration: underline;
  }
`

const TranslationWrapper = styled.div`
	padding-top: 1px;
`
